import _defineProperty from "E:/code/jinhua-step-two/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, Vue } from "vue-property-decorator";
import { getScenicDetail } from "@/api/api";
import { themeColor, themeIcon } from "@/main";
let ScenicDetail = class ScenicDetail extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "img_active", 0);

    _defineProperty(this, "base_url", process.env.VUE_APP_BASE_URL);

    _defineProperty(this, "scenic_detail", {});

    _defineProperty(this, "active_around_type", 0);

    _defineProperty(this, "is_play", false);

    _defineProperty(this, "totaltime", "");

    _defineProperty(this, "progress", 0);

    _defineProperty(this, "themeColor", themeColor);

    _defineProperty(this, "themeIcon", themeIcon);

    _defineProperty(this, "audio", null);

    _defineProperty(this, "id", 0);
  }

  // 获取景点详情
  async created() {
    const lng1 = sessionStorage.getItem("lng");
    const lat1 = sessionStorage.getItem("lat");
    const res = await getScenicDetail(+this.$route.query.id, lng1 || 1, lat1 || 1);
    this.scenic_detail = res.data;
    this.id = this.scenic_detail.pointSelectBO.scenicId;
  }

  mounted() {
    this.audio = this.$refs.audio;
    this.getDuration();
  } // 点击周边下方的menu


  clickMenu(index) {
    if (this.active_around_type !== index) {
      this.active_around_type = index;
    }
  } // 跳转到周边推荐


  jumpAroundRecommend() {
    this.$router.push({
      path: "/around-recommend",
      query: {
        id: this.scenic_detail.pointSelectBO.scenicId
      }
    });
  } // 跳转到高德地图页面


  jumpMap(target_lng, target_lat, name) {
    const lng = localStorage.getItem("lng");
    const lat = localStorage.getItem("lat");
    var ua = navigator.userAgent.toLowerCase();

    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //在微信就用微信地图
      this.openLocation({
        name: name,
        latitude: target_lat,
        longitude: target_lng,
        address: '',
        scale: 12,
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转

      });
    } else {
      let url = 'http://uri.amap.com/navigation?from=' + lng + ',' + lat + ',我的位置&to=' + target_lng + ',' + target_lat + ',' + name + '&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0';
      window.location.href = url;
    }
  } // 点击周边下的景点


  clickScenic(item) {
    sessionStorage.setItem("pointTypeId", item.pointTypeId);
    sessionStorage.setItem("point_id", item.id);
    this.$router.push("/scenic");
  }

  changeImg(index) {
    this.img_active = index;
  }

  getDuration() {
    this.totaltime = this.s_to_hs(parseInt(this.$refs.audio.duration));
  }

  updateTime() {
    this.suanshu();
  }

  suanshu() {
    let length = this.$refs.audio.currentTime / this.$refs.audio.duration * 100;
    this.progress = length;
  } // 秒数转换分+秒


  s_to_hs(duration) {
    var m = (Math.floor(duration / 60) || 0) + "分";
    var s = (duration % 60 || 0) + "秒";
    return m + s;
  }

  playAudio() {
    this.$refs.audio.play();
    this.is_play = true;
  }

  pauseAudio() {
    this.$refs.audio.pause();
    this.is_play = false;
  }

};
ScenicDetail = __decorate([Component], ScenicDetail);
export default ScenicDetail;